import { createAsyncAction } from 'services/actionConfigs';
import { ICouponReceiveDiscountSetting, ICouponReferralSetting } from '../types';
import { PREFIX_ACTIONS } from './constants';

const getCouponReceiveDiscountSetting = createAsyncAction<string, ICouponReceiveDiscountSetting>(PREFIX_ACTIONS + 'getCouponReceiveDiscountSetting');
const getReferralDiscountExitsCustomer = createAsyncAction<string, ICouponReferralSetting>(PREFIX_ACTIONS + 'getReferralDiscountExitsCustomer');
const getBirthdayDiscount = createAsyncAction<string, ICouponReceiveDiscountSetting>(PREFIX_ACTIONS + 'getBirthdayDiscount');

const couponActions = {
  getCouponReceiveDiscountSetting,
  getReferralDiscountExitsCustomer,
  getBirthdayDiscount,
};

export default couponActions;

